<template>
<section class="icon-link-boxes bg-gray-300 p-4">
    <div class="max-w-5xl mx-auto">
        <h2 v-if="headline" class="uppercase text-3xl vt:text-4xl text-primary-700 text-center leading-none mb-8" v-html="headline"></h2>
        <SmoothLoader class="grid">
            
            <Link v-for="link in links" :href="link.url" class="bg-primary-500 flex items-center rounded-lg h-full p-4 relative">
                <div class="fake-border absolute border-white border-solid border rounded-lg pointer-events-none" aria-hidden="true"></div>
                <div class="icon-container w-16 h-16 rounded-full bg-white flex items-center justify-center mr-4 border-2 border-primary-700 border-solid">
                    <span class="" v-html="link.icon || `<i class='fas fa-arrow-right'></i>`" aria-hidden="true"></span>
                </div>
                <div class="flex-1">
                    <span class="title block leading-tight uppercase text-white font-headline font-bold vt:text-lg ht:text-xl transition-colors" v-html="link.title"></span>
                </div>
            </Link>
            
        </SmoothLoader>
    </div>
</section>
</template>

<script>
export default {
    
    props: ['data'],

    setup(props) {
        return {
            ...props.data
        }
    }

}
</script>